import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from '../../services/authService';
import {
  AUTH_REDIRECT_MESSAGES,
  getLoginPath,
  setAuthRedirectNotice,
} from '../../utils/authRedirect';

/**
 * ProtectedRoute component
 * Wraps routes that require authentication
 * 
 * Usage:
 * <Route path="/dashboard" element={
 *   <ProtectedRoute>
 *     <Dashboard />
 *   </ProtectedRoute>
 * } />
 */
const ProtectedRoute = ({ children, requiredRole }) => {
  const location = useLocation();
  const loginPath = getLoginPath({
    requiredRole,
    pathname: location.pathname,
  });
  const currentUser = authService.getCurrentUser();
  const authenticatedHomePath =
    currentUser?.user_type === 'admin' ? '/admin/dashboard' : '/research';

  if (!authService.isAuthenticated()) {
    setAuthRedirectNotice({
      loginPath,
      message: AUTH_REDIRECT_MESSAGES.missing,
    });
    return <Navigate to={loginPath} replace />;
  }

  if (requiredRole && currentUser?.user_type !== requiredRole) {
    return <Navigate to={authenticatedHomePath} replace />;
  }

  return children;
};

export default ProtectedRoute;
